// import React from 'react';
// import { ChevronRightIcon } from '@heroicons/react/20/solid';
// import NavBar from 'components/layout/navbar';
// import HeroImageCarousel from './scrollingHeroImages';
// import { motion } from 'framer-motion';

// export default function Header() {
//   const titleVariants = {
//     hidden: { opacity: 0, y: 50, scale: 0.9 },
//     visible: {
//       opacity: 1,
//       y: 0,
//       scale: 1,
//       transition: {
//         duration: 1.2,
//         ease: 'easeOut',
//         delay: 0.3,
//       },
//     },
//   };

//   const paragraphVariants = {
//     hidden: { opacity: 0, x: -50 },
//     visible: {
//       opacity: 1,
//       x: 0,
//       transition: {
//         duration: 1,
//         ease: 'easeOut',
//         delay: 0.5,
//       },
//     },
//   };

//   const buttonVariants = {
//     hidden: { opacity: 0, scale: 0.8 },
//     visible: {
//       opacity: 1,
//       scale: 1,
//       transition: {
//         duration: 0.8,
//         ease: 'easeOut',
//         delay: 0.7,
//       },
//     },
//   };

//   return (
//     <header className="bg-primary-light-4 bg-hero-pattern">
//       <NavBar />

//       <div className="flex flex-col items-center justify-center w-full mx-auto hero-text py-10 lg:py-16 px-4 lg:px-0">
//         <motion.h1
//           variants={titleVariants}
//           initial="hidden"
//           animate="visible"
//           className="lg:max-w-4xl max-w-sm text-4xl lg:text-6xl text-center text-text-color tracking-normal font-medium"
//         >
//           We Put More{' '}
//           <span className="font-serif italic text-primary font-semibold">
//             Money{' '}
//           </span>
//           in
//           <br></br>{' '}
//           <span className="font-serif italic text-primary font-semibold">
//             Women’s
//           </span>{' '}
//           Hands.
//         </motion.h1>

//         <motion.p
//           variants={paragraphVariants}
//           initial="hidden"
//           animate="visible"
//           className="max-w-sm px-4 lg:px-0  lg:max-w-lg text-center py-6 text-dark-grey text-base md:text-lg font-medium"
//         >
//           We’re a robust ecosystem that empowers women to overcome the financing
//           challenges they face by providing financial solutions, mentorship, and
//           access to a supportive network.
//         </motion.p>

//         <motion.a
//           variants={buttonVariants}
//           initial="hidden"
//           animate="visible"
//           href="/loan"
//           className="inline-flex items-center rounded-full bg-text-color py-4 px-16 text-sm text-lg font-medium text-light-grey-4 drop-shadow-lg  transition duration-0 ease-in hover:drop-shadow-xl hover:duration-150"
//         >
//           Get Started
//           <ChevronRightIcon className="ml-1 h-5 w-5 " aria-hidden="true" />
//         </motion.a>
//       </div>
//       <HeroImageCarousel />
//     </header>
//   );
// }

import React, { useState } from 'react';
import { ChevronRightIcon } from '@heroicons/react/20/solid';
import NavBar from 'components/layout/navbar';
import HeroImageCarousel from './scrollingHeroImages';
import { motion } from 'framer-motion';

export default function Header() {
  const [showAnnouncement, setShowAnnouncement] = useState(true);

  const titleVariants = {
    hidden: { opacity: 0, y: 50, scale: 0.9 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 1.2,
        ease: 'easeOut',
        delay: 0.3,
      },
    },
  };

  const paragraphVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 1,
        ease: 'easeOut',
        delay: 0.5,
      },
    },
  };

  const buttonVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.8,
        ease: 'easeOut',
        delay: 0.7,
      },
    },
  };

  const announcementVariants = {
    hidden: { opacity: 0, y: -12 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: 'easeOut' },
    },
  };

  return (
    <header className="bg-primary-light-4 bg-hero-pattern">
      <NavBar />

      {showAnnouncement && (
        <motion.div
          variants={announcementVariants}
          initial="hidden"
          animate="visible"
          role="region"
          aria-label="WE-Elevate announcement"
          className="mx-auto max-w-5xl mt-4 px-4 lg:px-0"
        >
          <div className="relative flex flex-col md:flex-row items-center justify-between gap-3 bg-gradient-to-r from-primary to-primary/90 text-white rounded-2xl px-5 py-3 shadow-lg border border-white/10 backdrop-blur-md">
            {/* Left side: Text */}
            <div className="flex items-center gap-3 text-center md:text-left">
              <div className="hidden md:flex h-3 w-3 rounded-full bg-white/70 animate-pulse" />
              <p className="text-sm md:text-base font-medium leading-snug">
                <span className="font-semibold">Now Live:</span> The{' '}
                <span className="font-semibold text-white/90">
                  WE-Elevate Program
                </span>{' '}
                is open for applications. Empower your business to go global.
              </p>
            </div>

            {/* Right side: Buttons */}
            <div className="flex items-center gap-2 md:gap-3">
              <a
                href="/we-elevate"
                className="inline-flex items-center gap-2 bg-white text-primary font-semibold rounded-full px-4 py-2 text-sm shadow-md hover:bg-white/90 transition-all duration-200"
                aria-label="Learn more about WE-Elevate"
              >
                Learn more
                <ChevronRightIcon className="h-4 w-4" aria-hidden="true" />
              </a>

              <button
                onClick={() => setShowAnnouncement(false)}
                aria-label="Dismiss announcement"
                className="p-2 hover:bg-white/10 rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-white/30"
                title="Dismiss"
              >
                <span className="text-xl leading-none">&times;</span>
              </button>
            </div>
          </div>
        </motion.div>
      )}

      <div className="flex flex-col items-center justify-center w-full mx-auto hero-text py-10 lg:py-16 px-4 lg:px-0">
        <motion.h1
          variants={titleVariants}
          initial="hidden"
          animate="visible"
          className="lg:max-w-4xl max-w-sm text-4xl lg:text-6xl text-center text-text-color tracking-normal font-semibold"
        >
          Backing women-led{' '}
          <span className="font-serif italic text-primary font-semibold">
            SMEs{'  '}
          </span>
          and
          <br></br>{' '}
          <span className="font-serif italic text-primary font-semibold">
            MSMEs
          </span>{' '}
          to break new ground.
        </motion.h1>

        <motion.p
          variants={paragraphVariants}
          initial="hidden"
          animate="visible"
          className="max-w-sm px-4 lg:px-0  lg:max-w-lg text-center py-6 text-dark-grey text-base md:text-lg font-medium"
        >
          Shecluded is unlocking economic power for African women by bridging
          the gender finance gap with inclusive access to credit, business
          education, and community.
        </motion.p>

        <motion.a
          variants={buttonVariants}
          initial="hidden"
          animate="visible"
          href="/loan"
          className="inline-flex items-center rounded-full bg-text-color py-4 px-16 text-sm text-lg font-medium text-light-grey-4 drop-shadow-lg  transition duration-0 ease-in hover:drop-shadow-xl hover:duration-150"
        >
          Get Started
          <ChevronRightIcon className="ml-1 h-5 w-5 " aria-hidden="true" />
        </motion.a>
      </div>
      <HeroImageCarousel />
    </header>
  );
}
